import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactLoading from 'react-loading';

import { columns, worktags } from '../Common/enum';
import { toTitleCase, findRuleInRules } from '../../util/util';


import Header from '../Header/Header';
import DataGridContainer from "../../containers/DataGrid/DataGridContainer";
import FilterColumnsContainer from "../../containers/FilterColumns/FilterColumnsContainer";
import './Rules.css';

const WORKTAGS = worktags;

class Rules extends Component {

    constructor(props) {
        super(props);
        this.state = { loading: true, columnFilter: this.initColumnFilter() };
        this.renderRules = this.renderRules.bind(this);
        this.handleGridRowsUpdated = this.handleGridRowsUpdated.bind(this);
    }

    componentDidMount() {
        this.setState({ loading: false });
        this.props.fetchColumns();
        this.props.fetchRules();
    }

    initColumnFilter() {
        let col = [];
        for (let column of columns) {
            if (column.canBeHidden) {
                col.push({
                    label: column.name,
                    value: column.key
                });
            }
        }


        return col;
    }


    transformRules(rules) {
        if (Array.isArray(rules)) {
            rules = rules.map((rule, index) => {
                return {
                    id: rule.id,
                    lineNumber: <Link to={`/audit/${rule.id}`}>{index}</Link>,
                    typeCode: rule.type_code,
                    bankAccount: rule.bank_account,
                    customerRef: rule.customer_ref,
                    origId: rule.orig_id,
                    indIdNo: rule.ind_id_no,
                    boCustomer: rule.bo_customer,
                    vrn: rule.vrn,
                    matchBankAccountOnly: rule.matchBankAccountOnly !== undefined ? rule.matchBankAccountOnly.toString() : undefined,
                    area: rule.area,
                    description: rule.description,
                    company: rule.worktags.COMPANY,
                    costCenter: rule.worktags.COSTCENTER,
                    ledgerAccount: rule.worktags.LEDGERACCT,
                    fund: rule.worktags.FUND,
                    project: rule.worktags.PROJECT,
                    program: rule.worktags.PROGRAM,
                    grant: rule.worktags.GRANT,
                    gift: rule.worktags.GIFT,
                    balancingUnit: rule.worktags.BALANCING_UNIT,
                    activities: rule.worktags.ACTIVITIES,
                    assignee: rule.worktags.ASSIGNEE,
                    areaWorkTag: rule.worktags.AREA,
                    spendCat: rule.worktags.SPENDCAT,
                    revCat: rule.worktags.REVENUE_CATEGORY,
                    usage: rule.usage_count,
                    lastUsedDate: rule.last_used_date,
                    inactive: rule.inactive !== undefined ? rule.inactive.toString() : undefined
                };
            });
            if(!this.state.showInactive) {
                let filtered = [];
                for(let rule of rules) {
                    if(rule.inactive !== "true")
                        filtered.push(rule);
                }
                return filtered;
            }

            return rules;
        } else {
            return [];
        }
    }

    updateWorktagsObj(worktags, updated) {
        // console.log("IN updateWorktagsObj worktags:", worktags, " - updated ", updated);
        let newWorkTags = Object.assign({}, worktags);
        let workTagKeys = Object.keys(updated).filter((key) => { return WORKTAGS[key] })
        for (let key of workTagKeys) {
            let worktag = WORKTAGS[key];
            if (!updated[key]) {
                delete newWorkTags[worktag];
            } else {
                newWorkTags[worktag] = updated[key];
            }
        }
        console.log("WORKTAGS", newWorkTags);
        return { worktags: newWorkTags };
    }

    handleGridRowsUpdated(updates) {
        console.log("UPDATES OBJ:", updates);

        let { action, fromRowId, updated, rowIds } = updates;

        let keyName = Object.keys(updated)[0];
        console.log("***** KEY NAME******", keyName);

        //sanatize updated
        if (updated[keyName] === "") {
            updated[keyName] = null;
        }

        let newRules = this.props.rules.slice();
        let updatedRules = [];
        let updatedTime = (new Date()).toISOString();
        for (let id of rowIds) {
            if (!(action === "CELL_DRAG" && id === fromRowId)) {
                let rule = findRuleInRules(id, newRules);
                let audit = [...Object.values(rule.audit || {})];
                let newAuditObj;
                if (WORKTAGS[keyName]) {
                    if (!updated[keyName]) {
                        console.log("delete", keyName, "from rules", rule.worktags);
                        newAuditObj = { updatedTime, message: `${toTitleCase(keyName)} with value of ${rule.worktags[WORKTAGS[keyName]]} was deleted by current user.` };
                    } else if (!rule.worktags[WORKTAGS[keyName]]) {
                        console.log("create", keyName, " from rules", rule.worktags);
                        newAuditObj = { updatedTime, message: `${toTitleCase(keyName)} with value of ${updated[keyName]} was created by current user.` };
                    } else if (rule.worktags[WORKTAGS[keyName]].toString() !== updated[keyName].toString()) {
                        console.log("update", keyName, " from rules", rule.worktags);
                        newAuditObj = { updatedTime, message: `${toTitleCase(keyName)} was updated to ${updated[keyName]} from ${rule.worktags[WORKTAGS[keyName]]} by current user.` };
                    }
                }
                if (newAuditObj) {
                    console.log(newAuditObj.message);
                    audit.push(newAuditObj);
                }

                if (updated.area !== undefined && rule.area !== updated.area) {
                    let newAuditObj;
                    if (!rule.area) {
                        newAuditObj = { updatedTime, message: `Area with value of "${updated.area}" was created by current user.` };
                    } else if (rule.area && !updated.area) {
                        newAuditObj = { updatedTime, message: `Area with value of "${rule.area}" was deleted by current user.` };
                    } else {
                        newAuditObj = { updatedTime, message: `Area was updated to "${updated.area}" from "${rule.area}" by current user.` };
                    }
                    console.log(newAuditObj.message);
                    audit.push(newAuditObj);
                }

                if (updated.description !== undefined && rule.description !== updated.description) {
                    let newAuditObj;
                    if (!rule.description) {
                        newAuditObj = { updatedTime, message: `Description with value of "${updated.description}" was created by current user.` };
                    } else if (rule.description && !updated.description) {
                        newAuditObj = { updatedTime, message: `Description with value of "${rule.description}" was deleted by current user.` };
                    } else {
                        newAuditObj = { updatedTime, message: `Description was updated to "${updated.description}" from "${rule.description}" by current user.` };
                    }
                    console.log(newAuditObj.message);
                    audit.push(newAuditObj);
                }

                audit.sort((a, b) => a.updatedTime > b.updatedTime ? 1 : -1);

                let area = updated.area === undefined ? rule.area : updated.area;
                let description = updated.description === undefined ? rule.description : updated.description;

                let rowToUpdate = {
                    ...rule,
                    audit,
                    area: area || null,
                    description: description || null
                };
                let worktagsUpdated = this.updateWorktagsObj(rowToUpdate.worktags, updated);
                let updatedRow = Object.assign({}, rowToUpdate, worktagsUpdated);
                updatedRules.push(updatedRow);
                console.log("updatedRow from Rules:", updatedRow, " audit: ", audit);
            }
        }
        this.props.updateRules(updatedRules);
    }
    inactiveChanged = (e) => {
        console.log("inactive change: ", e.target.checked);
        // this.props.fetchRules();
        this.setState({ showInactive: e.target.checked });
      }

    renderRules() {
        console.log("RENDER rules", this.props);
        if (this.props.rules && this.props.rules.length > 0) {
            return (
                <div className="col-12">
                    <FilterColumnsContainer columnFilter={this.state.columnFilter} />
                    <input type="checkbox" name="chkShowInactive" className='mr-1' onClick={e => this.inactiveChanged(e)} />
                    <label for="chkShowInactive">Show Inactive</label>
                    <DataGridContainer
                        columns={this.props.filteredColumns && this.props.filteredColumns.length > 0 ? this.props.filteredColumns : this.props.columns}
                        data={this.transformRules(this.props.rules)}
                        handleGridRowsUpdated={this.handleGridRowsUpdated}
                    />
                </div>
            );
        } else {
            if (this.props.error) {
                return (<p className="col-12 alert alert-danger d-flex justify-content-between">There was an error retrieving rules</p>)
            }
            else {
                return (
                    <div className="col-12 loader">
                        <ReactLoading type={"spin"} color={"#666666"} height={'15%'} width={'15%'} />
                    </div>
                )
            }
        }
    }

    render() {
        return (
            <div id="rules">
                <div className="row">
                    <div className="col-6">
                        <Header title="Rules" />
                    </div>

                    <div className="col-6">
                        <Link to='/create' className='btn btn-primary float-right'>New Rule</Link>
                    </div>
                </div>
                {this.props.invalidWorktags && (
                    <div className="row">
                        <div className="col-12 alert alert-danger d-flex justify-content-between">
                            <span className="align-self-center">
                                {"Invalid Work Tags: " + Object.values(this.props.invalidWorktags).join(", ")}.
                                Your invalid tags have been cleared. You may reload the page to get the original values or resupply the new Work Tag.
                            </span>
                            <button className="btn btn-danger" onClick={() => window.location.reload()}>Reload</button>
                        </div>
                    </div>
                )}
                <div className="row">
                    {this.renderRules()}
                </div>
            </div>
        );
    }

}

export default Rules;



// WEBPACK FOOTER //
// ./src/components/Rules/Rules.js